import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ContactMenu from '../../ContactMenu';
import moment from 'moment';
import { backgroundColor } from 'styled-system';
import '../../../components/Messaging/containers/MessagingClient.scss';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const grayMarker = '/img/icons/destacado.svg';
const mintMarker = '/img/icons/bandera-mint.svg';
const mintCircle = '/img/icons/mono-verde.svg';
const grayCircle = '/img/icons/mono-gray.svg';
const menu = '/img/icons/menu-options.svg';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginBottom: 16,
  },
  name: {
    width: '100%',
    fontSize: 16,
    fontWeight: 'bold',
    paddingRight: 42,
    maxWidth: 476,
    color: '#10587f',
    lineHeight: 'normal',
  },

  textMsg: {
    padding: '0 16px',
    marginTop: 9,
  },
  card: {
    display: "flex",
    position: "relative",
    borderRadius: 4,
    border: "solid 1px #e7e7e7",
    padding: "0 16px 13px"
  }
}));

export default function MessageClient (props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [user, setUser] = useState(false)
  const { expanded, onChange, message, handleSave, handleClickDelete } = props;
  const [saved, setSaved] = useState();
  const [open, setOpen] = useState(false);
  const mobile = useMediaQuery('(max-width:768px)');

  let color ="rgb(53 185 182 / 0.1)";
  moment.locale('es');

  const handleOpenMenu = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    handleCloseMenu()
    setOpen(true);
  };

  const saveContact = () => {
    setSaved(true)
  }

  return (
    <div className={classes.root} style={{backgroundColor: color }}>
      <div className="msc-container">
        <div className="Photo">
        <div className="Photo_content">
                    <figure className="Photo_fig">
                                {mobile ?
                                    <img className="prueba-mobile" src={
                                        !user.imgProfile ? (

                                            user.role === 'lawyer' ? (
                                                !user.genero ? ('/img/avatars/avatares-cuadro-logo.svg') 
                                                : (user.genero == 'male' ? 
                                                    ('/img/avatars/avatares-cuadro-h.svg')
                                                        : ('/img/avatars/avatares-cuadro-m.svg')
                                                    )
                                            
                                            ):('/img/avatars/avatares-cuadro-logo.svg'))
                                            : 
                                            user.imgProfile
                            } alt="imagen de perfil" />
                            :
                            <img className="prueba-mobile" src={
                                !user.imgProfile ? (

                                    user.role === 'lawyer' ? (
                                        !user.genero ? ('/img/avatars/avatares-cuadro-logo.svg') 
                                        : (user.genero == 'male' ? 
                                            ('/img/avatars/avatares-cuadro-h.svg')
                                                : ('/img/avatars/avatares-cuadro-m.svg')
                                            )
                                    
                                    ):('/img/avatars/avatares-cuadro-logo.svg'))
                                    : 
                                    user.imgProfile
                            } alt="imagen de perfil" />
                        }
                    </figure>
                </div>





        </div>
        <div className="Name"><Typography className={classes.name}>{"Test"}</Typography></div>
        <div className="Flag" >
          <div
            className="Flag-save"
            onClick={() => {
            }}
          >
            <img
              src={saved && saved ? mintMarker : grayMarker}
              alt="Guardar contacto"
            />
          </div>
        </div>
        <div className="Date"><small className="message-date">{"fecha"}</small></div>
        <div className="Message">              
          <div className="message-sm">
            {"message.text"}
          </div>
        </div>
        <div className="MenuDots">
          <button className="menu-options-button" >
            <img src={menu} alt="Opciones" />
          </button>
          <ContactMenu
            anchorEl={anchorEl}
          />
        </div>
      </div>
    </div>
  );
}